import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { signAgreementThunk } from 'actions/agreements/AgreementsActions';
import { dogHighFive, heroGirlCombingDog } from 'assets/images';
import clsx from 'clsx';
import { PoweredByCuddles } from 'components/Cuddles/PoweredBy/PoweredByCuddles';
import { LeftColumn } from 'components/Layout/TwoColumns/LeftColumn/LeftColumn';
import { RightImageColumn } from 'components/Layout/TwoColumns/RightImageColumn/RightImageColumn';
import { usePhoneFormat } from 'hooks/usePhoneFormat';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMarketplace } from 'reducers/marketplace/MarketplaceSelectors';
import { getOnlineBookingAgreementSignatures } from 'reducers/onlineBooking/OnlineBookingSelectors';

import classes from './OnlineBookingSuccessStep.module.scss';

export const OnlineBookingSuccessStep: React.FC = () => {
    const dispatch = useDispatch();

    const agreementSignatures = useSelector(getOnlineBookingAgreementSignatures);
    const { name, phone, onlineBookingPreferences: olbPreferences } = useSelector(getMarketplace);

    const formattedPhone = usePhoneFormat(phone || '');

    React.useEffect(() => {
        for (const signature of agreementSignatures) {
            dispatch(signAgreementThunk(signature));
        }
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <LeftColumn contentClassName={clsx(classes.content)}>
                <FontAwesomeIcon icon={faCircleCheck} className={classes.icon} />

                <h1 className={clsx('h1', classes.title)}>
                    {olbPreferences.requireBookingRequest
                        ? 'Appointment requested!'
                        : 'Appointment booked!'}
                </h1>

                {olbPreferences.requireBookingRequest ? (
                    <p>
                        Your appointment request is currently pending. We&apos;ll notify you once
                        it&apos;s accepted. If you have any questions contact <b>{name}</b> at{' '}
                        <b>{formattedPhone}</b>
                    </p>
                ) : (
                    <p>
                        Check your inbox for an appointment confirmation. If you have any questions
                        contact <b>{name}</b> at <b>{formattedPhone}</b>
                    </p>
                )}

                <div>
                    <PoweredByCuddles />
                </div>

                <img src={dogHighFive} alt="Dog high five" className={classes.dogImage} />
            </LeftColumn>

            <RightImageColumn image={olbPreferences.promoImageUrl ?? heroGirlCombingDog} />
        </>
    );
};
